// extracted by mini-css-extract-plugin
module.exports = {"recentPosts":"recentPosts-module--recentPosts--8xoPF","recentPostsColumn":"recentPosts-module--recentPostsColumn--1WrNI","fontsLoading":"recentPosts-module--fonts-loading--35kxy"};